import {z} from 'zod';

export const driverInformationSchema = z.object({
  driverId: z.string().nullish(),
  driverFullName: z.string().nullish(),
  driverEmail: z.string().nullish(),
  driverPhone: z.object({
    countryCode: z.string(),
    number: z.string().nullish(),
    prefix: z.string().nullish(),
  }),
  driverIdentityCard: z.string().nullish(),
  contactPerson: z.string().nullish(),
});

export type DriverInformationFormFields = z.infer<typeof driverInformationSchema>;
